export var OdataOperator;
(function (OdataOperator) {
    OdataOperator["Equals"] = "eq";
    OdataOperator["Contains"] = "contains";
    OdataOperator["And"] = "and";
    OdataOperator["In"] = "in";
})(OdataOperator || (OdataOperator = {}));
